import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { AdUnitAmazon } from 'features/globalSetup/features/amazon/types/adUnitAmazon'
import { fromDTO } from './api/mapper'
import { GET_AD_UNIT_AMAZON_ALERTS } from './api/query'
import { Props, Return } from './types'

export const useGetAdUnitAmazonAlerts = ({ adUnitAmazonId }: Props): Return => {
  const [alerts, setAlerts] = useState<AdUnitAmazon['alerts']>([])

  useQuery(GET_AD_UNIT_AMAZON_ALERTS, {
    onCompleted: ({ node }): void => {
      if (node !== null) {
        setAlerts(fromDTO(node).alerts)
      }
    },
    variables: { id: adUnitAmazonId },
  })

  return { alerts }
}
